import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  top: -5px;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    margin-top: 15px;
    margin-bottom: 10px;
    color: ${colors.white};
  }
`;

export const Footer = styled.div`
  .form {
    font-weight: 300;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 20px;
  }

  .text {
    font-size: 14px;
    font-weight: 600;
    color: ${colors.white};
    margin-top: 16px;
  }
`;
